import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";
import IconButton from "@mui/material/IconButton";
import {
  LinkedinIcon,
  GmailIcon,
  GitIcon,
  MediumIcon,
  FBIcon,
  InstaIcon,
  TwiterIcon,
} from "../assets/icons/svgIcons";
import { myData } from "../data/myData";
import { pageMenu } from "../routes/menu";
import { bgHandler } from "../helpers/styles.helper";

const SocialMediaPanel = ({ isVertical }) => {
  return (
    <div
      className={classNames(
        isVertical
          ? "verticalSocailMediaContainer"
          : "horizontalSocailMediaContainer"
      )}
    >
      <IconButton href={myData.socialLinks.linkedin} target="_blank">
        <LinkedinIcon color="primary" fontSize="large" />
      </IconButton>
      <Link
        to={pageMenu.contactPage.path}
        onClick={() => {
          bgHandler(pageMenu.contactPage.path);
        }}
      >
        <IconButton>
          <GmailIcon color="primary" fontSize="large" />
        </IconButton>
      </Link>
      <IconButton href={myData.socialLinks.git} target="_blank">
        <GitIcon color="primary" fontSize="large" />
      </IconButton>
      <IconButton href={myData.socialLinks.medium} target="_blank">
        <MediumIcon color="primary" fontSize="large" />
      </IconButton>
      <IconButton href={myData.socialLinks.fb} target="_blank">
        <FBIcon color="primary" fontSize="large" />
      </IconButton>
      <IconButton href={myData.socialLinks.insta} target="_blank">
        <InstaIcon color="primary" fontSize="large" />
      </IconButton>
      <IconButton href={myData.socialLinks.twiter} target="_blank">
        <TwiterIcon color="primary" fontSize="large" />
      </IconButton>
    </div>
  );
};

SocialMediaPanel.propTypes = {
  isVertical: PropTypes.bool.isRequired,
};

export default SocialMediaPanel;
